import api from '../../plugins/api';

// GET /api/crm/cars/stockImport/runs â Ð¿Ð¾ÑÐ»ÐµÐ´Ð½Ð¸Ðµ Ð¿ÑÐ¾Ð³Ð¾Ð½Ñ Ð¸Ð¼Ð¿Ð¾ÑÑÐ° ÑÑÐ¾ÐºÐ° ÑÐ¾ ÑÐ²Ð¾Ð´ÐºÐ¾Ð¹.
const getStockImportRuns = (params) => {
  return api.get('/api/crm/cars/stockImport/runs', params);
};

export default getStockImportRuns;
